import {
  Box,
  BoxProps,
  ColorOptions,
  FontSizeOptions,
  Icon,
  IconNew,
  ModBox,
  Spacer,
  TextNew as Text
} from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { Dimensions, FlatList } from 'react-native'
import { CardData } from '../../../screens/SavedCard/types'
import {
  addTwoDecimalZeroes,
  CardVendors,
  convertHexToRGBA,
  getCardLogo,
  getCardType,
  getCardVendor,
  isIE
} from '../../../utils'
import { redThemeColor, THEME_PADDING } from '../../../utils/constants'
import { Button } from '../../Button'
import { Modal } from '../../Modal'
import { renderCardIcon } from '../CardType'
import { CVVInput } from '../CVVInput'
import { CardComponent } from './AddCard'
import { CustomSectionList } from './CustomSectionList'
import { styles } from './styles'
// TODO: Code Cleanup & Follow Code Pattern

interface CardDetails {
  cardNumber: string
  cardHolderName: string
  expiry: string
  cvv: string
  isSaveCard?: boolean
  token?: string
  scheme?: number
  type?: number
  isNewCard?: boolean
}

interface AddNewCardProps {
  show: Boolean
  onDismiss: () => void
  onPayment: (values: CardDetails) => void
  onCardNumberBlur?: (cardVendor: CardVendors, cardNumber: string) => void
  isValid?: boolean
  errMsg?: string
  amount?: string
  hide?: Boolean
  onCardNumberChange?: (cardNumber: string) => void
  theme?: any
  fotterComp?: React.ReactNode
  btnTitle?: string
  isEMI?: boolean
  onSaveCardVisible: (isVisible: boolean) => void
  setCurCardVendor: (cardVendor: string) => void
  isFoodCard?: boolean
  btnFooter?: React.ReactNode
  showSCCheckBox?: boolean
  cardNumFooter?: React.ReactNode
  onCardNumberValid?: (isValid: boolean) => void
  isSubscriptionEnabled?: boolean
}

const SavedCards = ({ cards: propCards, ...props }: any) => {
  const { showAddeNew, isFoodCard, isSubscriptionEnabled } = props
  const [cardItem, setCardItem] = useState<number | undefined>(-1)
  const [emiCardItem, setEMICardItem] = useState<number | undefined>(-1)
  const [NonEMICardItem, setNonEMICardItem] = useState<number | undefined>(-1)
  const [cvv, setCvv] = useState('')
  const [width, setWidth] = useState('')
  const [prevSelected, setPrevSelected] = useState(null)
  const [actionMenuInfo, setActionMenuInfo] = useState({ visible: false, layoutEvent: null, item: null })
  const [cards, setCards] = useState(propCards)
  const numberOfCards = propCards?.filter((item: any) => item.type !== 'HEADER')?.length
  console.log('******** props?.cards: ', propCards)
  console.log('numberOfCards: ', numberOfCards)
  const theme = props?.theme

  const addNewTapped = () => {
    console.log('addNewTapped', showAddeNew)
    props.onModalState(!showAddeNew)
    props?.onAddNewCard()
  }

  useEffect(() => {
    setCards(propCards)
  }, [propCards])

  if (props?.hide) {
    return null
  }

  if (props?.selected !== prevSelected) {
    setPrevSelected(props?.selected)
  }

  const _toggleActionMenu = () => {
    setActionMenuInfo({ ...actionMenuInfo, visible: !actionMenuInfo.visible })
  }
  const onClickItem = (item: any, index: number) => {
    //console.log('===> onClickItem item, index, cardItem: ', item, index, cardItem)
    if (cardItem !== index) {
      setCvv('')
      setCardItem(index)
      props?.onCardSelected({
        ...item,
        isNewCard: false,
      })
      props?.enablePayButton('', item)
    }
  }
  const style = styles(theme, THEME_PADDING)
  const renderItem = ({ item, index }: { item: CardData; index: number }) => {
    const maxCvvLength = getCardVendor(Number(item.scheme)) === 'amex' ? 4 : 3
    return (
      <Box width={width}>
        <Box
          {...style.listItemContainer}
          bg={
            cardItem === index
              ? (convertHexToRGBA(theme?.brandColor, 30) as ColorOptions)
              : (theme?.bodyBgColor as ColorOptions)
          }>
          <Box {...style.listButton}>
            <Box {...style.leftContainer} onPress={() => onClickItem(item, index)} underlayColor={'ALTO_DISABLED'}>
              <Box {...style.cardIconContainer}>
                {renderCardIcon(
                  getCardVendor(isFoodCard ? item.id : parseInt(item.scheme, 10)),
                  getCardLogo(isFoodCard ? item.id : parseInt(item.scheme, 10)),
                )}
              </Box>
            </Box>
            <Spacer direction={'horizontal'} size={'SMALL'} />
            <Box flex={1}>
              <Box flexDirection="row" justifyContent="space-between" width={'100%'}>
                <Box
                  testID={`item-${isFoodCard ? index : item?.subtype}`}
                  onPress={() => onClickItem(item, index)}
                  underlayColor={'ALTO_DISABLED'}>
                  <Text
                    color={theme?.bodyTextColor as ColorOptions}
                    fontSize={14}
                    type={'body14'}
                    fontFamily="jioType-medium">
                    {isFoodCard ? item.name : getCardType(item?.subtype)}
                  </Text>
                  <Text
                    type={'body12'}
                    color={convertHexToRGBA(theme?.bodyTextColor, 40) as ColorOptions}
                    fontFamily="jioType-medium">
                    {isFoodCard ? item?.cardNumber : `ending with ${item?.cardNumber?.replace(/[^0-9]/g, '')}`}
                  </Text>
                </Box>
                <Box>
                  {isFoodCard ? (
                    <>
                      {item?.cardBalance?.balance ? (
                        <Box>
                          <Text {...style.balanceText}>{addTwoDecimalZeroes(item?.cardBalance?.balance)}</Text>
                        </Box>
                      ) : (
                        <Button
                          isLoading={item?.cardBalance?.isLoading}
                          title={!item?.cardBalance?.isLoading ? 'Get Balance' : ''}
                          type={'specific'}
                          onPress={() => props?.onClickGetBalance(item, index)}
                          testID={'getBalance-' + index}
                        />
                      )}
                    </>
                  ) : (
                    <Box bottom={5} right={0} width={80}>
                      {cardItem === index && !isFoodCard && !item?.isCvvLess ? (
                        <CVVInput
                          autoFocus
                          isTextInput={true}
                          maxCvvLength={maxCvvLength}
                          isValidCVV={() => { }}
                          theme={theme}
                          cvv={cvv}
                          setCvv={(values) => {
                            if (maxCvvLength === values.length) {
                              props?.enablePayButton(values, item)
                            } else {
                              props?.enablePayButton('', item)
                            }
                            setCvv(values)
                          }}
                        />
                      ) : null}
                    </Box>
                  )}
                </Box>
                <Box
                  alignSelf={'center'}
                  alignItems="center"
                  justifyContent={'center'}
                  underlayColor={'ALTO_DISABLED'}
                  testID={'open-modal'}
                  onPress={(e: any) => {
                    const event = e?.nativeEvent
                    const customValue = {
                      top: event?.clientY - event?.offsetY,
                      left: event?.clientX - event?.offsetX,
                      height: actionMenuInfo?.layoutEvent?.height,
                      width: actionMenuInfo?.layoutEvent?.width,
                    }
                    props.setDeleteCardItem(item)
                    setActionMenuInfo({
                      ...actionMenuInfo,
                      visible: !actionMenuInfo.visible,
                      layoutEvent: customValue,
                      item: item,
                    })
                  }}
                  onLayout={({ nativeEvent }) => {
                    setActionMenuInfo({ ...actionMenuInfo, layoutEvent: nativeEvent.layout })
                  }}>
                  <IconNew id="MORE" size={20} color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions} />
                </Box>
              </Box>
              {isFoodCard && (
                <>
                  <Spacer size={10} />
                  <Box>
                    <Text {...style.error}>{item?.cardBalance?.error}</Text>
                  </Box>
                </>
              )}
            </Box>
          </Box>
        </Box>
        <Box width={'100%'} maxWidth={'500px'} height={'1px'} bg={'BRAND_COLOR_GRAY_3'} />
        {cardItem === index && props?.scFotterComp ? props?.scFotterComp : undefined}
      </Box>
    )
  }

  const showRightIcon = () => {
    if (props?.selected !== 'savedcards') {
      return (
        <Box>
          <Icon id={'DEFAULT_CARD'} size={'BIGGER'} />
          <Box {...style.cardCount}>
            <Text
              type={'label'}
              fontSize={'10px' as FontSizeOptions}
              color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}>{`${cards.length}`}</Text>
          </Box>
        </Box>
      )
    }
    return null
  }

  const savedSelected = props?.selected === 'savedcards'

  const renderSectionHeader = ({ item }: any) => {
    const title = item?.title ?? ''
    if (title === '') {
      return null
    }
    const deviceWidth = Dimensions.get('window').width

    return (
      <Box paddingHorizontal="BIG" height={40} paddingVertical={8} width={deviceWidth}>
        <Text
          testID="sectionHeader"
          color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
          fontFamily="jiotype-medium"
          lineHeight={20}
          fontSize={14}>
          {title}
        </Text>
      </Box>
    )
  }

  const onClickEMIItem = (item: any, index: number) => {
    if (emiCardItem !== index) {
      setCvv('')
      setEMICardItem(index)
      setNonEMICardItem(-1)
      props?.enablePayButton('', item)
      props?.onCardSelected({
        ...item,
        isNewCard: false,
      })
    }
  }

  const onClickNonEMIItem = (item: any, index: number) => {
    if (NonEMICardItem !== index) {
      setCvv('')
      setNonEMICardItem(index)
      setEMICardItem(-1)
      props?.enablePayButton('', item)
      props?.onCardSelected({
        ...item,
        isNewCard: false,
      })
    }
  }

  const renderData = (item: any, index: number, cardItem: number | undefined, isEMIEligible: boolean) => {
    const maxCvvLength = getCardVendor(item.scheme) === 'amex' ? 4 : 3
    console.log('===> item.scheme', item.scheme)
    return (
      <>
        <Box
          {...style.listItemContainer}
          bg={
            cardItem === index
              ? (convertHexToRGBA(theme?.brandColor, 5) as ColorOptions)
              : (theme?.bodyBgColor as ColorOptions)
          }
          testID={'emi-' + index}
          onPress={() => (isEMIEligible ? onClickEMIItem(item, index) : onClickNonEMIItem(item, index))}>
          <Box {...style.listButton}>
            <Box {...style.leftContainer}>
              <Box {...style.cardIconContainer}>
                {renderCardIcon(getCardVendor(parseInt(item.scheme, 10)), getCardLogo(parseInt(item.scheme, 10)))}
              </Box>
              <Spacer direction={'horizontal'} size={'SMALL'} />
              <Box>
                <Text color={theme?.bodyTextColor as ColorOptions} type={'body14'} fontFamily="jioType-medium">
                  {getCardType(item?.subtype)}
                </Text>
                <Text
                  type={'body12'}
                  color={convertHexToRGBA(theme?.bodyTextColor, 40) as ColorOptions}
                  fontFamily="jioType-medium">
                  {`ending with ${item?.cardNumber?.replace(/[^0-9]/g, '')}`}
                </Text>
              </Box>
            </Box>
            <Box position={'absolute'} top={5} right={0} direction={'row'} width={80} bottom={undefined}>
              {cardItem === index ? (
                <CVVInput
                  autoFocus
                  isTextInput={true}
                  maxCvvLength={maxCvvLength}
                  isValidCVV={() => { }}
                  theme={theme}
                  cvv={cvv}
                  setCvv={(values) => {
                    if (maxCvvLength === values.length) {
                      props?.enablePayButton(values, item, isEMIEligible)
                    } else {
                      props?.enablePayButton('', item)
                    }
                    setCvv(values)
                  }}
                />
              ) : null}
            </Box>
          </Box>
          {cardItem === index ? (
            <>
              <Box {...style.cvvFormContainer}>
                <Box {...style.emptyContainer} />
                <Box flex={1} paddingTop="SMALL">
                  {cvv.length === maxCvvLength && isEMIEligible && props?.scFotterComp ? props.scFotterComp : undefined}
                </Box>
              </Box>
            </>
          ) : null}
        </Box>
        <Box width={'100%'} maxWidth={'500px'} height={'1px'} bg={'BRAND_COLOR_GRAY_3'} />
      </>
    )
  }

  const renderEMIItem = ({ item, index }: { item: any; index: number }) => {
    return renderData(item, index, emiCardItem, true)
  }

  const renderNonEMIItem = ({ item, index }: { item: any; index: number }) => {
    return renderData(item, index, NonEMICardItem, false)
  }

  if (props?.isEMI) {
    return (
      <Box paddingBottom={savedSelected ? 'SMALL' : 0}>
        <Box
          {...style.container}
          paddingVertical={'MEDIUM_BIG'}
          hoverColor={!savedSelected ? 'LIGHTEST_GREY' : 'TRANSPARENT'}
          onPress={() => props?.setSelected('savedcards')}>
          <Text color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}>
            {props?.emiCards?.length > 1
              ? `Cards eligible for EMI(${props?.emiCards?.length})`
              : `Card eligible for EMI(${props?.emiCards?.length})`}
          </Text>
          {showRightIcon()}
          {
            <Box testID="add-new" onPress={addNewTapped} underlayColor="LIGHTEST_GREY">
              <Text color={theme?.brandColor as ColorOptions} type="body14" fontWeight="700">
                {'+ Add New'}
              </Text>
            </Box>
          }
        </Box>
        <Spacer size={16} />
        {prevSelected === 'savedcards' ? (
          <FlatList extraData={[cardItem, cvv]} data={props?.emiCards} renderItem={renderEMIItem} />
        ) : null}

        {props?.nonEMICards?.length >= 1 && (
          <Box
            {...style.container}
            paddingVertical={20}
            hoverColor={!savedSelected ? 'LIGHTEST_GREY' : 'TRANSPARENT'}
            onPress={() => props?.setSelected('savedcards')}>
            <Text fontSize={14} fontWeight="700" color={theme?.bodyTextColor as ColorOptions}>
              Pay entire amount using
            </Text>
            {showRightIcon()}
          </Box>
        )}

        {props?.nonEMICards?.length >= 1 && prevSelected === 'savedcards' ? (
          <FlatList extraData={[cardItem, cvv]} data={props?.nonEMICards} renderItem={renderNonEMIItem} />
        ) : null}

        <AddNewModal
          show={showAddeNew}
          onDismiss={addNewTapped}
          btnFooter={props?.btnFooter}
          onPayment={(values) => {
            //setShowAddNew(false)
            props?.onModalState(!showAddeNew)
            props?.onCardPayment(values)
          }}
          onCardNumberBlur={props?.onCardNumberBlur}
          onCardNumberChange={props?.onCardNumberChange}
          amount={props?.amount}
          isValid={props?.isValid}
          errMsg={props?.errMsg}
          theme={theme}
          fotterComp={props?.cardFotterComp}
          btnTitle={props?.btnTitle}
          isEMI={props?.isEMI}
          onSaveCardVisible={props?.onSaveCardVisible}
          setCurCardVendor={props?.setCurCardVendor}
          showSCCheckBox={props?.showSCCheckBox}
          cardNumFooter={props?.cardNumFooter}
          onCardNumberValid={props?.onCardNumberValid}
        />
      </Box>
    )
  }

  const renderActionMenu = () => {
    return (
      <Box {...deleteStyles.container} testID={'actionMenuModal'}>
        <Box
          top={actionMenuInfo?.layoutEvent?.top + actionMenuInfo?.layoutEvent?.height / 2 + 2}
          onPress={() => { }}
          right={
            Dimensions.get('window').width - actionMenuInfo?.layoutEvent?.left - actionMenuInfo?.layoutEvent?.width / 2
          }
          {...deleteStyles.shadowStyle}
          bg={theme.bodyBgColor as ColorOptions}>
          <Box
            {...deleteStyles.listItem}
            onPress={() => {
              props.setConfirmAlertInfo(true)
              _toggleActionMenu()
            }}>
            <Text fontSize={12} fontFamily="jioType-medium" color={redThemeColor as ColorOptions}>
              Delete Card
            </Text>
          </Box>
        </Box>
      </Box>
    )
  }

  return (
    <Box paddingBottom={savedSelected ? 'SMALL' : 0} flex={1}>
      <ModBox show={actionMenuInfo.visible} testID={'open-modal'} onPress={_toggleActionMenu}>
        {ReactDOM.createPortal(renderActionMenu(), document.body)}
      </ModBox>
      {props?.headerComp && props.headerComp}
      <Box
        {...style.container}
        paddingVertical={'MEDIUM_BIG'}
        hoverColor={!savedSelected ? 'LIGHTEST_GREY' : 'TRANSPARENT'}
        onPress={() => props?.setSelected('savedcards')}>
        {props?.selected === 'savedcards' ? (
          <Text color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}>
            {numberOfCards > 1 ? `${numberOfCards} saved cards ` : 'Saved card'}
          </Text>
        ) : (
          <Text color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions} type="body14">
            {numberOfCards > 1 ? `${numberOfCards} saved cards ` : 'Saved card'}
          </Text>
        )}
        {showRightIcon()}
        <Box testID="add-new" onPress={addNewTapped} underlayColor="LIGHTEST_GREY">
          <Text color={theme?.brandColor as ColorOptions} type="body14" fontWeight="700">
            {'+ Add New'}
          </Text>
        </Box>
      </Box>
      {props?.scHeaderComp && props?.scHeaderComp}
      {prevSelected === 'savedcards' ? (
        <CustomSectionList
          measureDetail={(width: string) => {
            setWidth(width)
          }}
          renderHeader={renderSectionHeader}
          data={cards}
          renderItem={renderItem}
          extraData={[cardItem, cvv]}
        />
      ) : null}

      <AddNewModal
        show={showAddeNew}
        onDismiss={addNewTapped}
        onPayment={(values) => {
          props?.onModalState(!showAddeNew)
          props?.onCardPayment(values)
        }}
        onCardNumberBlur={props?.onCardNumberBlur}
        onCardNumberChange={props?.onCardNumberChange}
        amount={props?.amount}
        isValid={props?.isValid}
        errMsg={props?.errMsg}
        theme={theme}
        fotterComp={props?.fotterComp}
        btnTitle={props?.btnTitle}
        isEMI={props?.isEMI}
        onSaveCardVisible={props?.onSaveCardVisible}
        setCurCardVendor={props?.setCurCardVendor}
        btnFooter={props?.btnFooter}
        cardNumFooter={props?.cardNumFooter}
        onCardNumberValid={props?.onCardNumberValid}
        showSCCheckBox={props?.showSCCheckBox}
        isSubscriptionEnabled={isSubscriptionEnabled}
      />
    </Box>
  )
}

const AddNewModal = ({
  show,
  onDismiss,
  onPayment,
  onCardNumberBlur,
  onCardNumberChange,
  amount,
  isValid,
  errMsg,
  theme,
  fotterComp,
  btnTitle,
  onSaveCardVisible,
  btnFooter,
  cardNumFooter,
  onCardNumberValid,
  showSCCheckBox,
  isSubscriptionEnabled,
}: AddNewCardProps) => {
  if (show) {
    return (
      <Modal
        containerTopPadding={isIE() ? 5 : undefined}
        type={'BottomTop'}
        title={'Add New Card'}
        show={true}
        isFullWidth
        onDismiss={onDismiss}
        theme={theme}>
        <CardComponent
          hide={!show}
          onPayment={onPayment}
          btnFooter={btnFooter}
          onCardNumberBlur={onCardNumberBlur}
          onCardNumberChange={onCardNumberChange}
          onCardNumberValid={onCardNumberValid}
          amount={amount}
          isValid={isValid}
          errMsg={errMsg}
          theme={theme}
          fotterComp={fotterComp}
          btnTitle={btnTitle}
          onSaveCardVisible={onSaveCardVisible}
          showSCCheckBox={showSCCheckBox}
          cardNumFooter={cardNumFooter}
          isSubscriptionEnabled={isSubscriptionEnabled}
        />
      </Modal>
    )
  }
  return null
}

const deleteStyles = {
  container: {
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    position: 'absolute',
  } as BoxProps,
  shadowStyle: {
    position: 'absolute',
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 2,
    shadowColor: 'GREY_MATTE',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: convertHexToRGBA('#DE0000', 24) as ColorOptions,
    zIndex: 5,
    flexDirection: 'column',
    underlayColor: 'WHITE',
    //width: 104,
  } as BoxProps,
  listItem: {
    pv: 10,
    ph: 20,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
}

export { SavedCards }
